import { Link} from "@tanstack/react-router";

const navigation = [
  { name: "Accessibility checker", href: "/" },
  { name: "Issue fixes", href: "/issue-fixes" },
  { name: "Toolbar", href: "/accessibility-toolbar" },
  { name: "Statement generator", href: "/statement" },
];

export function Navbar() {

  return (
    <nav className="cy:bg-white cy:border-b cy:border-gray-200 cy:shadow-sm cy:px-2">
      <div className="cy:max-w-7xl cy:mx-auto">
        <div className="cy:self-stretch cy:bg-white cy:inline-flex cy:justify-start cy:items-start cy:gap-6">
          {navigation.map((item) => {
            return (
              <Link
                key={item.name}
                to={item.href}
                activeProps={{
                  className: "cy:border-primary cy:text-primary",
                }}
                inactiveProps={{
                  className: "cy:border-transparent",
                }}
                className="cy:inline-flex cy:items-center cy:px-1 cy:py-4 cy:border-b-4 cy:text-sm cy:font-medium cy:transition-colors cy:duration-200 cy:text-foreground! cy:hover:text-primary! cy:outline-0! cy:shadow-none!"
              >
                {item.name}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
